// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2Sro3","Open":"SideDrawer_Open__2XETh","Close":"SideDrawer_Close__2YVih","Logo":"SideDrawer_Logo__2tosZ"};